import { render, staticRenderFns } from "./Rank.vue?vue&type=template&id=72728ddc&scoped=true&lang=html&"
import script from "./Rank.vue?vue&type=script&lang=js&"
export * from "./Rank.vue?vue&type=script&lang=js&"
import style0 from "./Rank.vue?vue&type=style&index=0&id=72728ddc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72728ddc",
  null
  
)

export default component.exports